import getPotlatchConfig from 'utils/getPotlatchConfig';

// Site-wide config the Story component renders. Fetched separately from
// StoryQuery so it's cached across requests instead of re-queried per story.
export async function getStoryConfig() {
  const [blacklist, donateAsk] = await Promise.all([
    getPotlatchConfig('mprnews/related-stories-blacklist'),
    getPotlatchConfig('mprnews/donate-ask-config'),
  ]);
  return { blacklist, donateAsk };
}

export default getStoryConfig;
